<template>
    <span data-goods-contract>
        <!--商品详情页显示-->
        <div class="item-protect" v-if="list.length" @click.deb="bindShow()">
            <ul>
                <li v-for="contItem in list"><img :src="contItem.iconUrl">{{contItem.ctItemname}}</li>
            </ul>
        </div>
        <!-- 弹出框 -->

         <transition name="ncbottom">
            <div class="nctouch-bottom-mask mask-show" v-show="show" ref="layer">
                <div class="nctouch-bottom-mask-bg" @click="show=false" @touchmove="excludeTouch"></div>
                    <div class="nctouch-bottom-mask-block">
                        <div class="nctouch-bottom-mask-top" @touchmove="excludeTouch">
                            <div class="close"><i class="closed" @click="show=false" data-name="服务说明">ဝန္ေဆာင္မွုရွင္းျပခ်က္</i></div>
                        </div>
                        <div class="contract-options">
                            <div class="contract-content" ref='scroll'>
                                <ul>
                                    <li class="contract-item" v-for="item in list">
                                        <div class="contract-thumb"><img :src="item.iconUrl"/></div>
                                        <dl>
                                            <dt>{{item.ctItemname}}</dt>
                                            <dd>{{item.desc}}</dd>
                                        </dl>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
             </div>
        </transition>
    </span>
</template>
<script>
    /**
     * 消保服务
     */
    var iscrollInstance;
    export default {
        //外部传入参数
        props: {

            // 消保信息列表
            list: {
                type: Array,
                required: false
            }
        },
        /*
         * 自身数据,一定要一个function
         */
        data() {
            return {
                show: false
            }
        },
        /**
         * 计算属性
         */
        computed: {},

        /**
         * 监听属性变动
         */
        watch: {
            show: function (value) {
                if (value) {
                    this.$nextTick(function () {
                        if (iscrollInstance) {
                            iscrollInstance.refresh()
                        } else {
                            iscrollInstance = new IScroll(this.$refs.scroll, {
                                scrollX: false,
                                scrollY: true,
                                click: false
                            });
                        }
                    })

                }

            }
        },
        mounted() {
            var $layer = this.$refs.layer;
            var $body = document.getElementsByTagName("body")[0];
            $body.appendChild($layer);
        },
        beforeUpdate() {

        },
        /**
         * 自定义方法
         */
        methods: {
            excludeTouch: function (event) {
                event.preventDefault();
                return false;
            } ,
            bindShow:function () {
                this.show=true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/goods-contract/goods-contract.vue